export default __webpack_public_path__ + "static/media/ic_paste_24px.bc23e0ac.svg";